// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dw-a";
export var fulfillmentFormRail = "_dw-9";
export var headerTitleRow = "_dw-c";
export var orderDetailsWrapper = "_dw-7";
export var orderLinkTrigger = "_dw-2";
export var paymentInformationGrid = "_dw-h";
export var paymentSummaryColumn = "_dw-i";
export var shipmentContainer = "_dw-b";
export var shipmentDetailsMainPane = "_dw-8";
export var shipmentNavigationCard = "_dw-5";
export var shipmentNavigationRail = "_dw-3";
export var shipmentNavigationRailHeader = "_dw-4";
export var shipmentSummaryFact = "_dw-e";
export var shipmentSummaryGrid = "_dw-d";
export var shipmentSummaryMetadataRow = "_dw-f";
export var shipmentSummaryTags = "_dw-g";
export var shipmentWorkspace = "_dw-0";
export var shipmentWorkspaceContent = "_dw-6";
export var shipmentWorkspaceHeader = "_dw-1";